import React from 'react';
import { motion } from 'framer-motion';
import { Star } from 'lucide-react';
import { BANNER_URL } from './data';
import { useBooking } from './BookingContext';
export function Hero() {
  const {
    openBooking
  } = useBooking();
  return <section id="inicio" className="w-full pt-16 sm:pt-20 bg-[#faf0e7]" data-id="element-179" data-mp="9lbkteco9zjx">
      <div className="relative w-full" data-id="element-180" data-mp="4mrvd3yve5mt">
        <img src={BANNER_URL} alt="Ginger Briones Studio — salón de belleza de lujo en Queens, New York" className="block w-full h-auto" data-id="element-181" data-mp="4jm69oq8r3r3" />

        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.9,
        ease: [0.22, 1, 0.36, 1]
      }} className="absolute hidden lg:block top-[75%] left-[70%] max-w-[360px] text-center w-[294px] h-[63px]" data-id="element-182" data-mp="x9usbrnwe8ay">
          <div className="flex items-center justify-center gap-2 text-mid mb-3" data-id="element-183" data-mp="neaugzprwzjk">
            <span className="flex items-center gap-0.5 text-champagne" data-id="element-184" data-mp="3d33f4zea6vla">
              {Array.from({
              length: 5
            }).map((_, i) => <Star key={i} className="w-3 h-3 fill-current" strokeWidth={0} data-id="element-185" data-mp="384s5oprwen3l" data-mpi={i} />)}
            </span>
            <span className="font-body font-medium text-[8px] tracking-[1.5px] uppercase whitespace-nowrap" data-id="element-186" data-mp="3j6oe7qokeyt9">
              Luxury Experience · 5.0 Google Reviews
            </span>
          </div>
          <motion.button type="button" onClick={openBooking} whileHover={{
          y: -2
        }} className="metallic-reserve-button inline-block w-full px-4 py-3 font-body text-[9px] font-semibold uppercase tracking-[3px] text-white outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-187" data-mp="39cpboqkkxd0s">
            Reservar Mi Cita
          </motion.button>
        </motion.div>
      </div>

      <motion.div initial={{
      opacity: 0,
      y: 16
    }} animate={{
      opacity: 1,
      y: 0
    }} transition={{
      delay: 0.15,
      duration: 0.55,
      ease: [0.22, 1, 0.36, 1]
    }} className="lg:hidden px-5 py-6 text-center border-t border-gold-ultra-light bg-[#faf0e7]" data-id="element-188" data-mp="2vi55xb5imm16">
        <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 text-mid mb-4" data-id="element-189" data-mp="s2b7vyavsj55">
          <span className="flex items-center gap-0.5 text-champagne" data-id="element-190" data-mp="nb1j0zx5pjub">
            {Array.from({
            length: 5
          }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-current" strokeWidth={0} data-id="element-191" data-mp="ichy92uaue3j" data-mpi={i} />)}
          </span>
          <span className="font-body font-medium text-[9px] tracking-[2px] uppercase" data-id="element-192" data-mp="deyke41ik3c4">
            Luxury Experience · 5.0 Google Reviews
          </span>
        </div>
        <motion.button type="button" onClick={openBooking} whileTap={{
        scale: 0.98
      }} className="metallic-reserve-button inline-block w-full px-6 py-4 font-body text-[10px] font-semibold uppercase tracking-[4px] text-white outline-none focus-visible:ring-2 focus-visible:ring-champagne focus-visible:ring-offset-2 focus-visible:ring-offset-[#faf0e7]" data-id="element-193" data-mp="162uer23m1j5q">
          Reservar Mi Cita
        </motion.button>
      </motion.div>
    </section>;
}